import React from 'react';
import styled, { css } from 'styled-components';

const Container = styled.fieldset`
  border: 1px solid #444;
  padding: 10px;
  margin-bottom: 10px;
  legend {
    color: #ddd;
    font-size: 12px;
    padding: 0 10px;
  }
  ${(props) => props.clickable && css`
    cursor: pointer;
    & * {
      cursor: pointer;
    }
    &:hover {
      opacity: 0.8;
    }
  `}
`;

const Fieldset = ({ label, clickable, onClick, children, className }) => {
  return (
    <Container clickable={clickable} onClick={onClick} className={className}>
      <legend>{label}</legend>
      {children}
    </Container>
  );
};

export default Fieldset;
